// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-icon {\n  vertical-align: middle; }\n", "",{"version":3,"sources":["webpack://src/styles/itemlink.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB,EAAA","sourcesContent":[".nav-icon {\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
